import {
  SHIFT_DATE_RANGE,
  SHIFT_TYPE,
  SELECT_TYPE,
  ACTIVE_TYPE,
  SHIFT_DOCTORS,
  SHIFT_CATEGORIES,
  SHIFT_PAYMENT_TYPE,
  SHIFT_TOGGLE_IN_ON_TIME,
  SHIFT_TOGGLE_OUT_ON_TIME,
  SHIFT_GP,
  SHIFT_NON_GP_TIME_RANGE,
  SHIFT_NON_GP,
  DELETE_SHIFT_NON_GP_DAY_TIME_RANGE,
  SUBMIT_FORM,
  STATUS_DOCTOR_SHIFT_CREATE,
  FETCH_ACTIVE_DOCTOR_SHIFTS,
  FETCH_ACTIVE_DOCTOR_SHIFTS_SUCCESS,
  SHIFT_GET_DATA,
  SHIFT_GET_DATA_SUCCESS,
  SHIFT_SEARCH_TYPE,
  SHIFT_SEARCH_TYPE_DOCTOR,
  SHIFT_SEARCH_TYPE_DATE_RANGE,
  SHIFT_SEARCH_SUBMIT_STATUS,
  SHIFT_SEARCH_TYPE_SHIFT_CATEGORY,
  SHIFT_EDIT,
  SHIFT_EDIT_SUBMIT_FORM,
  SHIFT_EDIT_SUCCESS,
  SHIFT_SET_IS_CHECKED,
  SUBMIT_BULK_DELETE,
  SHIFT_CHANGE_DIALOG_BOX,
  SHIFT_SET_DELETE_ID,
  SUBMIT_DELETE,
  SHIFT_EDIT_DOCTOR_ID,
  SHIFT_EDIT_START_DATE,
  SHIFT_EDIT_END_DATE,
  SHIFT_EDIT_PAYMENT_TYPE,
  SHIFT_EDIT_REMARK,
  SHIFT_EDIT_AUTO_TOGGLE_IN_ON_THAT_TIME,
  SHIFT_EDIT_AUTO_TOGGLE_OUT_ON_THAT_TIME,
  SHIFT_EDIT_CATEGORY_ID,
  SHIFT_EDIT_STATUS,
  CLEAR_NEW_DOCTOR_SHIFT,
} from "../constants/doctorShift.constants";

export const changeShiftDateRange = (shift_date_range) => {
  return {
    type: SHIFT_DATE_RANGE,
    shift_date_range: shift_date_range,
  };
};

export const changeShiftType = (shift_type) => {
  return {
    type: SHIFT_TYPE,
    shift_type: shift_type,
  };
};

export const changeSelectType = (select_type) => {
  return {
    type: SELECT_TYPE,
    select_type: select_type,
  };
};

export const changeActiveType = (active_type) => {
  return {
    type: ACTIVE_TYPE,
    active_type: active_type,
  };
};

export const changeShiftDoctors = (shift_doctors) => {
  return {
    type: SHIFT_DOCTORS,
    shift_doctors: shift_doctors,
  };
};

export const changeShiftCategories = (shift_categories) => {
  return {
    type: SHIFT_CATEGORIES,
    shift_categories: shift_categories,
  };
};

export const changeShiftPaymentType = (shift_payment_type) => {
  return {
    type: SHIFT_PAYMENT_TYPE,
    shift_payment_type: shift_payment_type,
  };
};

export const changeToggleInOnThatTime = (auto_toggle_in_on_that_time) => {
  return {
    type: SHIFT_TOGGLE_IN_ON_TIME,
    auto_toggle_in_on_that_time: auto_toggle_in_on_that_time,
  };
};

export const changeToggleOutOnThatTime = (auto_toggle_out_on_that_time) => {
  return {
    type: SHIFT_TOGGLE_OUT_ON_TIME,
    auto_toggle_out_on_that_time: auto_toggle_out_on_that_time,
  };
};

export const changeShiftGP = (shift_gp) => {
  return {
    type: SHIFT_GP,
    shift_gp: shift_gp,
  };
};

export const changeShiftNonGPTimeRange = (shift_non_gp_time_range) => {
  return {
    type: SHIFT_NON_GP_TIME_RANGE,
    shift_non_gp_time_range: shift_non_gp_time_range,
  };
};

export const changeShiftNonGP = (shift_non_gp) => {
  return {
    type: SHIFT_NON_GP,
    shift_non_gp: shift_non_gp,
  };
};

export const deleteShiftNonGPDayTimeRange = (updated_shift_non_gp) => {
  return {
    type: DELETE_SHIFT_NON_GP_DAY_TIME_RANGE,
    updated_shift_non_gp: updated_shift_non_gp,
  };
};

export const submitForm = (shift_data) => {
  return {
    type: SUBMIT_FORM,
    shift_data: shift_data,
  };
};

export const setStatusDoctorShiftCreate = (shift_create_status) => {
  return {
    type: STATUS_DOCTOR_SHIFT_CREATE,
    shift_create_status: shift_create_status,
  };
};

export const fetchActiveDoctorShift = (page) => {
  return {
    type: FETCH_ACTIVE_DOCTOR_SHIFTS,
    page: page,
  };
};

export const getActiveDoctorShiftSuccess = (doctor_active_shifts) => {
  return {
    type: FETCH_ACTIVE_DOCTOR_SHIFTS_SUCCESS,
    doctor_active_shifts: doctor_active_shifts,
  };
};

export const getShifts = (page, searchDataObject) => {
  return {
    type: SHIFT_GET_DATA,
    page: page,
    searchDataObject: searchDataObject,
  };
};

export const getShiftsSuccess = (shift_data) => {
  return {
    type: SHIFT_GET_DATA_SUCCESS,
    shift_data: shift_data,
  };
};

export const onChangeShiftSearchType = (search_type) => {
  return {
    type: SHIFT_SEARCH_TYPE,
    search_type: search_type,
  };
};

export const onChangeShiftSearchTypeDoctor = (search_doctor) => {
  return {
    type: SHIFT_SEARCH_TYPE_DOCTOR,
    search_doctor: search_doctor,
  };
};

export const onChangeShiftSearchTypeShiftCategory = (search_shift_category) => {
  return {
    type: SHIFT_SEARCH_TYPE_SHIFT_CATEGORY,
    search_shift_category: search_shift_category,
  };
};

export const onChangeShiftSearchTypeDateRange = (search_date_range) => {
  return {
    type: SHIFT_SEARCH_TYPE_DATE_RANGE,
    search_date_range: search_date_range,
  };
};

export const onChangeShiftSearchSubmitStatus = (search_submit_status) => {
  return {
    type: SHIFT_SEARCH_SUBMIT_STATUS,
    search_submit_status: search_submit_status,
  };
};

export const shiftEdit = (shift_id) => {
  return {
    type: SHIFT_EDIT,
    shift_id: shift_id,
  };
};

export const onSubmitShiftEditForm = (edit_shift_data) => {
  return {
    type: SHIFT_EDIT_SUBMIT_FORM,
    shift_data: edit_shift_data,
  };
};

export const onSubmitShiftEditSuccess = (edit_shift_data) => {
  return {
    type: SHIFT_EDIT_SUCCESS,
    shift_data: edit_shift_data,
  };
};

export const onChangeEditStatus = (status) => {
  return {
    type: SHIFT_EDIT_STATUS,
    status: status,
  };
};

export const onChangeShiftSetIsChecked = (shift_data) => {
  return {
    type: SHIFT_SET_IS_CHECKED,
    shift_data: shift_data,
  };
};

export const submitBulkDelete = (deleted_id_array, searchDataObject, page) => {
  return {
    type: SUBMIT_BULK_DELETE,
    deleted_id_array: deleted_id_array,
    searchDataObject: searchDataObject,
    page: page,
  };
};

export const onChangeShiftEditDoctorID = (doctor_id) => {
  return {
    type: SHIFT_EDIT_DOCTOR_ID,
    doctor_id: doctor_id,
  };
};

export const onChangeShiftEditStartDate = (start_date) => {
  return {
    type: SHIFT_EDIT_START_DATE,
    start_date: start_date,
  };
};

export const onChangeShiftEditEndDate = (end_date) => {
  return {
    type: SHIFT_EDIT_END_DATE,
    end_date: end_date,
  };
};

export const onChangeShiftEditPaymentType = (payment_type) => {
  return {
    type: SHIFT_EDIT_PAYMENT_TYPE,
    payment_type: payment_type,
  };
};

export const onChangeShiftEditRemark = (remark) => {
  return {
    type: SHIFT_EDIT_REMARK,
    remark: remark,
  };
};

export const onChangeShiftEditAutoToggleInOnThatTime = (auto_toggle_in_on_that_time) => {
  return {
    type: SHIFT_EDIT_AUTO_TOGGLE_IN_ON_THAT_TIME,
    auto_toggle_in_on_that_time: auto_toggle_in_on_that_time,
  };
};

export const onChangeShiftEditAutoToggleOutOnThatTime = (auto_toggle_out_on_that_time) => {
  return {
    type: SHIFT_EDIT_AUTO_TOGGLE_OUT_ON_THAT_TIME,
    auto_toggle_out_on_that_time: auto_toggle_out_on_that_time,
  };
};

export const onChangeShiftEditShiftCategoryID = (shift_category_id) => {
  return {
    type: SHIFT_EDIT_CATEGORY_ID,
    shift_category_id: shift_category_id,
  };
};

export const onChangeDialogBoxStatus = (dialog_box_status) => {
  return {
    type: SHIFT_CHANGE_DIALOG_BOX,
    dialog_box_status: dialog_box_status,
  };
};

export const onChangeShiftDeleteID = (delete_id) => {
  return {
    type: SHIFT_SET_DELETE_ID,
    delete_id: delete_id,
  };
};
export const submitDelete = (delete_id, searchDataObject, page) => {
  return {
    type: SUBMIT_DELETE,
    delete_id: delete_id,
    searchDataObject: searchDataObject,
    page: page,
  };
};

export const clearNewDoctorShift = () => {
  return {
    type: CLEAR_NEW_DOCTOR_SHIFT,
  };
}